var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "neu-cards-slider-professional" },
    [
      _c(
        "b-row",
        { staticClass: "centered d-flex neu-cards-slider-funct" },
        [
          _c(
            "b-col",
            {
              staticClass: "text-center pt-lg-0 pt-5",
              staticStyle: { display: "inline-block" },
              attrs: { cols: "12" }
            },
            [
              !_vm.hasHeadingSlot
                ? _c("div", [
                    _vm.title
                      ? _c(
                          "h2",
                          {
                            staticClass: "mobile-font mb-5 mt-2 mt-sm-5",
                            staticStyle: { "font-size": "35px" }
                          },
                          [_vm._v(_vm._s(_vm.title))]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "h3",
                      {
                        staticClass: "mobile-font my-0 my-sm-2 mx-0 mx-sm-5",
                        staticStyle: {
                          color: "#3238C4",
                          "font-size": "25px",
                          display: "inline-block"
                        }
                      },
                      [_vm._v(" " + _vm._s(_vm.subtitle) + "\n        ")]
                    )
                  ])
                : _c("div", [_vm._t("heading")], 2)
            ]
          ),
          _vm._v(" "),
          _c("carousel", {
            staticClass: "d-none d-touch-screens-block",
            attrs: { cards: _vm.cards }
          }),
          _vm._v(" "),
          _c(
            "carousel-3d",
            {
              staticClass: "d-block d-touch-screens-none",
              attrs: { height: 500, border: 0 }
            },
            _vm._l(_vm.cards, function(professional, i) {
              return _c("slide", {
                key: i,
                staticStyle: { "background-color": "transparent" },
                attrs: { index: i },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(ref) {
                        var index = ref.index
                        var isCurrent = ref.isCurrent
                        var leftIndex = ref.leftIndex
                        var rightIndex = ref.rightIndex
                        return [
                          _c("neu-card-professional", {
                            class: {
                              current: isCurrent,
                              onLeft: leftIndex >= 0,
                              onRight: rightIndex >= 0
                            },
                            attrs: {
                              "data-index": index,
                              src: professional.photo,
                              title: professional.name,
                              subtitle: professional.ratingsNumber.toString(),
                              titleLines: 1,
                              subtitleLines: 1
                            }
                          })
                        ]
                      }
                    }
                  ],
                  null,
                  true
                )
              })
            }),
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-35ea83b0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35ea83b0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/ui/NeuCardsSliderProfessionalsSelector.vue
// module id = 3733
// module chunks = 30